<template>
  <div class="quan">
     <div class="list">
       <div class="item">
         <div class="left">
           <img v-if="data.type === 'eleme'" class="label" src="http://mz.qingting365.cn/img/take-out/label-ele.png" alt="">
           <img v-if="data.type === 'meituan'" class="label" src="http://mz.qingting365.cn/img/take-out/label-mt.png" alt="">
           <img v-if="data.type === 'eleme'" src="http://mz.qingting365.cn/img/take-out/mark-ele.png" alt="" class="mark">
           <img v-if="data.type === 'meituan'" src="http://mz.qingting365.cn/img/take-out/mark-mt.png" alt="" class="mark">
           <div class="content">
             <h2 class="title">{{data.title}}</h2>
             <div class="info">
               <span id="elePrice" class="price">{{data.price}}</span>
               <span class="unit">元</span>
               <span id="eleTip" class="tip">{{data.tip}}</span>
             </div>
           </div>
         </div>
         <div class="right">
           <a :href="data.url" class="btn red">免费领取</a>
         </div>
       </div>
     </div>
  </div>
</template>

<script>
export default {
  name: "Quan",
  props: {
    data: {
      type: Object,
      default: {} 
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.quan {
  width: 100%;
}
.list {
  display: flex;
  padding: 0 10px;
  width: 100%;
  flex-direction: column;
  -webkit-box-direction: normal;
}
.item {
  display: flex;
  height: 90px;
  width: 100%;
  border-radius: 14px;
  border-bottom: 10px;
  margin-top: 14px;
  background: #fff;
}
.label {
  width: 53px;
  position: absolute;
  top: 0;
  left: 0;
}
.red {
  background-color: #ff5b73;
  color: #fff;
}
.btn {
  text-decoration: none;
  display: inline-block;
  width: 80%;
  height: 32px;
  line-height: 32px;
  border-radius: 16px;
  text-align: center;
}
.mark {
  position: absolute;
  bottom: 0;
  left: 0px;
  width: 50px;
}
.content {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 90px;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 42px;
}
.title {
  font-weight: 600;
  font-size: 15px;
}
.price {
  color: #ff304d;
  font-size: 26px;
  font-weight: 600;
  position: relative;
  top: 2px;
}
.unit {
  color: #ff304d;
}
.tip {
  background-color: #ffebe3;
  padding: 2px 4px;
  border-radius: 2px;
  color: #aa1e3b;
}
.left {
  width: 72%;
  height: 90px;
  position: relative;
}
.left::before {
  content: '';
    position: absolute;
    top: -6px;
    right: -6px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #EBEBEB;
}
.left::after {
  content: '';
  position: absolute;
  bottom: -6px;
  right: -6px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #EBEBEB;
}
.right {
  width: 28%;
  height: 90px;
  position: relative;
  border-left: 2px dashed #eee;
  display: flex;
  align-items: center;
  justify-content: center;
}
.right::before {
  content: '';
  position: absolute;
  top: -6px;
  left: -6px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #EBEBEB;
}
.right::after {
  content: '';
  position: absolute;
  bottom: -6px;
  left: -6px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #EBEBEB;
}
</style>



// WEBPACK FOOTER //
// src/components/quan.vue